import {reactive} from 'vue';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastItem {
  id: number;
  type: ToastType;
  message: string;
  duration: number;
}

const toasts = reactive<ToastItem[]>([]);
let nextToastId = 1;

const pushToast = (type: ToastType, message: string, duration = 2800): number => {
  const id = nextToastId++;
  toasts.push({id, type, message, duration});
  if (duration > 0) {
    setTimeout(() => removeToast(id), duration);
  }
  return id;
};

const removeToast = (id: number): void => {
  const index = toasts.findIndex((toast) => toast.id === id);
  if (index !== -1) {
    toasts.splice(index, 1);
  }
};

export const showSuccessToast = (message: string): number => pushToast('success', message);
export const showErrorToast = (message: string): number => pushToast('error', message, 3500);
export const showInfoToast = (message: string): number => pushToast('info', message);

export const useToast = () => {
  return {
    toasts,
    pushToast,
    removeToast,
    showSuccessToast,
    showErrorToast,
    showInfoToast,
  };
};

